var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-card',{class:("paper " + _vm.cardClass),attrs:{"no-body":""}},[_c('b-card-body',{class:(_vm.bodyClass + " paper-body")},[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }